import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 14, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} fill={fillColor} viewBox='0 0 512 512' className={className}>
      <g>
        <g>
          <g>
            <path
              d='M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M256,480
            C132.288,480,32,379.712,32,256S132.288,32,256,32s224,100.288,224,224S379.712,480,256,480z'
            />
            <circle cx='256' cy='256' r='32' />
            <circle cx='368' cy='256' r='32' />
            <circle cx='144' cy='256' r='32' />
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
